import React, { useState, useEffect } from "react";
import Card from '../../lib/card/card-component';
import ResumeTable from '../../lib/resume-table-component/resume-table-component';
import {useVariableContext} from '../../variableContext';
import { useUserContext } from '../../userContext';
import { useZammadContext } from '../../context/ZammadContext';
import { GET_TICKET_STATS_ZAMMAD } from "../../utils/ZammadServices";
import { motion } from "framer-motion";
import tiposSolicitudes from '../../data/tiposSolicitudes.json';


export default function Home() {

    const [solicitudes, setSolicitudes] = useState([]);
    const [ticketStats, setTicketStats] = useState({ openIds: [], tickets: {} });
    const { root, setRoot } = useVariableContext();
    const { startLoader , stopLoader  } = useUserContext();
    const { zammadInstance, zammadUser } = useZammadContext();


    useEffect(() => {
       startLoader();
       try {
         // Cargar tipos de solicitudes desde JSON local
         const solicitudesHabilitadas = tiposSolicitudes.items.filter(
           item => item.fields.Habilitado === true
         );
         setSolicitudes(solicitudesHabilitadas);
         setRoot({ ListadoApp: solicitudesHabilitadas.map(x => x.fields), ...root });
       } catch (error) {
         console.error('Error al cargar tipos de solicitudes:', error);
       } finally {
         stopLoader();
       }
    }, [])

    // Una sola llamada para todas las cards
    useEffect(() => {
        if (!zammadInstance || !zammadUser) return;

        GET_TICKET_STATS_ZAMMAD(zammadInstance, zammadUser.id)
            .then(response => {
                setTicketStats({
                    openIds: response.data?.user?.open_ids || [],
                    tickets: response.data?.assets?.Ticket || {}
                });
            })
            .catch(error => console.error('Error al cargar ticket stats:', error));
    }, [zammadInstance, zammadUser]);


    return (
      <>
        <h1>Elige el tipo de solicitud que deseas realizar</h1>
        <ResumeTable />
        {solicitudes.map((item, index) => (
          <Card
            key={index}
            item={item.fields}
            ticketStats={ticketStats}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
          />
        ))}
        {/* End Card Section */}
      </>
    );
}